(() => {
  const storageKey = "nextGolfHioCart";
  const hioPageUrl = "/pages/hio-skill-test";
  const routeRoot = window.Shopify?.routes?.root || "/";

  const getFlag = () => {
    try {
      return window.sessionStorage.getItem(storageKey) === "true";
    } catch (_error) {
      return false;
    }
  };

  const setFlag = (enabled) => {
    try {
      if (enabled) window.sessionStorage.setItem(storageKey, "true");
      else window.sessionStorage.removeItem(storageKey);
    } catch (_error) {
      // Links still retain their standard Shopify destination.
    }
  };

  const updateContinueShoppingLinks = () => {
    if (!getFlag()) return;
    document.querySelectorAll("[data-hio-continue-shopping]").forEach((link) => {
      link.href = hioPageUrl;
    });
  };

  const isHioItem = (item) => item?.properties?.["_HIO Skill Test"] === "true";

  const normalizeHioEntries = async () => {
    try {
      const response = await fetch(`${routeRoot}cart.js`, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const hioItems = items.filter(isHioItem);

      if (hioItems.length > 0) {
        setFlag(true);
      } else if (items.length > 0) {
        setFlag(false);
      }

      const seenMonths = new Set();
      const updates = {};
      let needsUpdate = false;

      hioItems.forEach((item) => {
        const month = String(item.properties?.["Challenge Month"] || "").trim().toLowerCase();
        const duplicateMonth = month && seenMonths.has(month);
        const desiredQuantity = duplicateMonth ? 0 : 1;
        if (month) seenMonths.add(month);
        if (item.quantity !== desiredQuantity) {
          updates[item.key] = desiredQuantity;
          needsUpdate = true;
        }
      });

      if (needsUpdate) {
        const updateResponse = await fetch(`${routeRoot}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ updates }),
        });
        if (updateResponse.ok) window.location.reload();
      }
    } catch (_error) {
      // The cart remains usable if normalization cannot run.
    } finally {
      updateContinueShoppingLinks();
    }
  };

  const start = () => {
    updateContinueShoppingLinks();
    normalizeHioEntries();
    new MutationObserver(updateContinueShoppingLinks).observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
